import { graphql } from '@/gql'

/** The first few people of each People table; the drawer's contacts tab and its badge read it. */
export const ClientDrawerContactsQuery = graphql(`
  query ClientDrawerContacts($client: ID!, $accounts: [ID!]) {
    clientTeam: clientRelationTeam(
      client: $client
      accounts: $accounts
      first: 5
      orderBy: [{ field: ACCOUNT_ROLE, order: ASC }]
    ) {
      data {
        id
        accountRole
        user {
          id
          ...ClientContactLabel
        }
      }
      paginatorInfo {
        total
      }
    }
    team: clientRelationOwners(
      client: $client
      accounts: $accounts
      first: 5
      orderBy: [{ field: NAME, order: ASC }]
    ) {
      data {
        id
        user {
          id
          ...ClientContactLabel
        }
      }
      paginatorInfo {
        total
      }
    }
    recruiters: clientRelationCounterpartOwners(
      client: $client
      accounts: $accounts
      first: 5
      orderBy: [{ field: NAME, order: ASC }]
    ) {
      data {
        id
        user {
          id
          ...ClientContactLabel
        }
        owned {
          __typename
          ... on SupplierClient {
            id
            supplier {
              id
              name
            }
          }
        }
      }
      paginatorInfo {
        total
      }
    }
    relation: clientRelation(id: $client) {
      id
      ... on CompanySupplier {
        viewerCanManageStaffingAgencies
      }
    }
  }
`)
